(() => {
  const drawerSelector = '#Details-menu-drawer-container';
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const chatSelector = [
    '#shopify-chat',
    'shopify-chat',
    '[data-shopify-chat]',
    'iframe[src*="shopifychat" i]',
    'iframe[src*="shopifyinbox" i]',
    'iframe[title*="chat" i]'
  ].join(',');

  let lastDrawerOpen = null;
  let viewportFrame = 0;
  let mutationFrame = 0;

  function getDrawer() {
    return document.querySelector(drawerSelector);
  }

  function getTrigger(sheet) {
    return sheet?.closest('.disclosure')?.querySelector('.localization-form__select');
  }

  function setSheetClosed(sheet) {
    if (!sheet) return;

    sheet.hidden = true;
    sheet.classList.remove('un-market-sheet--above');
    sheet.style.removeProperty('--un-localization-max-height');

    const trigger = getTrigger(sheet);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeLocalizationSheets(scope = document, except = null) {
    scope.querySelectorAll('[data-un-localization-sheet]:not([hidden])').forEach((sheet) => {
      if (sheet !== except) setSheetClosed(sheet);
    });
  }

  function positionDesktopSheet(sheet) {
    if (!sheet || sheet.hidden || !desktopQuery.matches) return;

    const trigger = getTrigger(sheet);
    if (!trigger) return;

    sheet.classList.remove('un-market-sheet--above');

    const triggerRect = trigger.getBoundingClientRect();
    const gap = 10;
    const viewportPadding = 14;
    const below = window.innerHeight - triggerRect.bottom - gap - viewportPadding;
    const above = triggerRect.top - gap - viewportPadding;
    const openAbove = below < 300 && above > below;
    const available = Math.max(220, Math.floor(openAbove ? above : below));

    sheet.classList.toggle('un-market-sheet--above', openAbove);
    sheet.style.setProperty('--un-localization-max-height', `${available}px`);
  }

  function revealCurrentChoice(sheet) {
    if (!sheet || sheet.hidden) return;
    const current = sheet.querySelector('.disclosure__link[aria-current="true"]');
    if (!current) return;

    requestAnimationFrame(() => {
      current.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  function syncOpenSheet(sheet) {
    if (!sheet || sheet.hidden) return;
    positionDesktopSheet(sheet);
    revealCurrentChoice(sheet);
  }

  function chatCandidates() {
    return document.querySelectorAll(chatSelector);
  }

  function hideChat(element) {
    if (element.dataset.unChatHidden === 'true') return;
    element.dataset.unChatHidden = 'true';
    element.dataset.unPreviousDisplay = element.style.display;
    element.style.display = 'none';
  }

  function restoreChat(element) {
    if (element.dataset.unChatHidden !== 'true') return;
    element.style.display = element.dataset.unPreviousDisplay || '';
    delete element.dataset.unChatHidden;
    delete element.dataset.unPreviousDisplay;
  }

  function syncDrawerState(forceChatSync = false) {
    const drawer = getDrawer();
    const open = Boolean(drawer?.open && mobileQuery.matches);

    if (open === lastDrawerOpen && !forceChatSync) return;
    lastDrawerOpen = open;

    document.documentElement.classList.toggle('un-mobile-menu-open', open);
    document.body.classList.toggle('un-mobile-menu-open', open);

    chatCandidates().forEach((element) => {
      if (open) hideChat(element);
      else restoreChat(element);
    });

    if (!open) closeLocalizationSheets();
  }

  function bindDrawer() {
    const drawer = getDrawer();
    if (!drawer || drawer.dataset.unV4Bound === 'true') return;

    drawer.dataset.unV4Bound = 'true';
    drawer.addEventListener('toggle', () => syncDrawerState(true));
  }

  function updateOpenSheets() {
    document.querySelectorAll('[data-un-localization-sheet]:not([hidden])').forEach(syncOpenSheet);
  }

  function scheduleViewportUpdate(syncDrawer = false) {
    if (viewportFrame) return;

    viewportFrame = requestAnimationFrame(() => {
      viewportFrame = 0;
      updateOpenSheets();
      if (syncDrawer) syncDrawerState(true);
    });
  }

  /* Close another picker before Shopify opens the requested one. */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.localization-form__select');
    if (!trigger) return;

    const sheet = trigger.closest('.disclosure')?.querySelector('[data-un-localization-sheet]');
    closeLocalizationSheets(document, sheet);

    requestAnimationFrame(() => syncOpenSheet(sheet));
  }, true);

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-un-localization-close]');
    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      setSheetClosed(closeButton.closest('[data-un-localization-sheet]'));
      return;
    }

    const openSheet = event.target.closest('[data-un-localization-sheet]');
    const trigger = event.target.closest('.localization-form__select');

    if (!openSheet && !trigger) closeLocalizationSheets();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeLocalizationSheets();
  });

  const observer = new MutationObserver(() => {
    if (mutationFrame) return;

    mutationFrame = requestAnimationFrame(() => {
      mutationFrame = 0;
      bindDrawer();

      // Only rescan chat elements while the mobile drawer is actually open.
      // This keeps dynamically injected chat widgets hidden without doing a
      // full-document selector pass for every unrelated DOM mutation.
      if (lastDrawerOpen || Boolean(getDrawer()?.open && mobileQuery.matches)) {
        syncDrawerState(true);
      }
    });
  });

  function init() {
    bindDrawer();
    syncDrawerState(true);

    observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('resize', () => scheduleViewportUpdate(true), { passive: true });
    window.addEventListener('orientationchange', () => scheduleViewportUpdate(true), { passive: true });
    window.addEventListener('scroll', () => {
      if (
        desktopQuery.matches &&
        document.querySelector('[data-un-localization-sheet]:not([hidden])')
      ) {
        scheduleViewportUpdate(false);
      }
    }, { passive: true });

    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', () => scheduleViewportUpdate(true));
      mobileQuery.addEventListener('change', () => scheduleViewportUpdate(true));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
